export default function setSelect($rootScope, API, UserCache) {
  'ngInject'
  var directive = {
    restrict: 'E',
    scope: {
      tags: '=tags',
      multiple: '=multiple',
    },
    template: '<input type="hidden" class="bigdrop" id="setSelect" style="width:300px;"/>',
    link: selectLink,
  }

  return directive

  function selectLink($scope, $element, $attr) {
    var auth = UserCache.getObject()
    $.ajaxSetup({
      headers: {
        'X-Collectible-Platform': 'QP2',
        Authorization: 'Bearer ' + auth.jwt,
      },
    })
    $('#setSelect').select2({
      ajax: {
        url: function (t, page) {
          var start, limit
          if (page === 1) {
            start = 0
            limit = 25
          } else {
            limit = page * 25
            start = limit - 25
          }
          return API.API_URL + 'admin/sets/search?start=' + start + '&limit=' + 25
        },
        dataType: 'json',
        quietMillis: 250,
        data: function (t, page) {
          return {
            page: page,
            t: t,
          }
        },
        results: function (data, page) {
          $rootScope.$broadcast('setList', data.results)
          return {
            results: data.results,
            more: page + 25 < data.ct,
          }
        },
      },
      multiple: $scope.multiple,
      escapeMarkup: function (markup) {
        return markup
      }, // let our custom formatter work
      minimumInputLength: 1,
      formatResult: formatState,
      formatSelection: formatStateSelection,
    })

    function formatState(state) {
      if (state.loading) {
        return state.text
      }

      var markup =
        "<div class='select2-result-repository clearfix'>" +
        "<div class='select2-result-repository__meta'>" +
        "<div class='select2-result-repository__title'>" +
        "<div style='font-size: 12px; color: #333; opacity: 0.8;'>Channel: <b>" +
        state.ch.t +
        '</b></div>' +
        "<div style='font-size: 14px; color: #333; opacity: 0.9;'>ID: <b>" +
        state.id +
        '</b></div>' +
        "<div style='font-size: 14px; color: #333; opacity: 0.9;'>Title: <b>" +
        state.t +
        '</b></div>' +
        '</div>' +
        '</div></div>'

      return markup
    }

    function formatStateSelection(state) {
      return state.id + ': ' + state.t
    }
  }
}
